import React from "react";
import RevisionHistory from "../RevisionHistory";
import RevisionRequestPanel from "../RevisionRequestPanel";
import BrandLogo from "../BrandLogo";
import { legalNotesText } from "../../lib/calc";

export default function ProposalExtras({ cur, hasVexatious, inRevision, issuerName, negotiable, proposalChanges, quote, resetQuantities, sendRevision, totals }) {
  return (
    <>
      {(negotiable || inRevision) && (
        <RevisionRequestPanel negotiable={negotiable} inRevision={inRevision} revision={quote.revision_request}
          items={quote.items} changes={proposalChanges} onReset={resetQuantities} onSend={sendRevision} issuerName={issuerName} />
      )}
      <RevisionHistory history={quote.revision_history} cur={cur} collapsible className="mt-6" />

      {quote.terms_conditions && (
        <div className="rounded-xl border border-slate-200 bg-card p-5 mt-6">
          <h3 className="text-sm font-semibold text-slate-900 mb-2">Termini e Condizioni</h3>
          <p className="text-sm text-slate-500 leading-relaxed whitespace-pre-line">{quote.terms_conditions}</p>
        </div>
      )}

      {hasVexatious && (
        <div data-testid="vexatious-clauses-block" className="rounded-xl border border-amber-200 bg-amber-50/60 p-5 mt-4">
          <h3 className="text-sm font-semibold text-amber-900 mb-2">Clausole Specifiche ex Art. 1341-1342 c.c.</h3>
          <p className="text-sm text-amber-800/90 leading-relaxed whitespace-pre-line">{quote.vexatious_clauses}</p>
        </div>
      )}

      {quote.watermark && (
        <div data-testid="myquoteflow-watermark" className="mt-6 text-center">
          <a href="https://myquoteflow.it" target="_blank" rel="noreferrer" className="inline-flex items-center gap-1.5 text-xs font-medium text-slate-400 hover:text-primary transition-colors">
            <BrandLogo variant="mark" size="sm" /> Preventivo interattivo creato con MyQuoteFlow — Provalo gratis
          </a>
        </div>
      )}

      {legalNotesText(quote, totals) && (
        <div data-testid="public-legal-note" className="rounded-xl border border-slate-200 bg-slate-50/60 p-4 mt-4">
          <p className="text-[11px] font-semibold uppercase tracking-wide text-slate-500 mb-1">Note legali / Riferimenti normativi</p>
          <p className="text-xs text-slate-600 leading-relaxed whitespace-pre-line">{legalNotesText(quote, totals)}</p>
        </div>
      )}
    </>
  );
}
